import {
    Chart,
    ChartLegend,
    ChartNoDataOverlay,
    ChartSeries,
    ChartSeriesItem,
    ChartSeriesLabels,
    ChartTitle
} from '@progress/kendo-react-charts';
import axios from 'axios';

import 'hammerjs';
import { AccessToken } from '../../config/AccessToken';
import { useLocalization } from '@progress/kendo-react-intl';
import { useEffect, useState } from 'react';


export const MissionPalpieChart = () => {

    const SERVER_URL = process.env.REACT_APP_SERVER_URL;

    const [missionsNotStarted, setMissionsNotStarted] = useState(0);
    const [missionsAssigned, setMissionsAssigned] = useState(0);
    const [missionsDoing, setMissionsDoing] = useState(0);
    const [missionsTotal, setMissionsTotal] = useState(0);

    const [error, setError] = useState('');

    const localizationService = useLocalization();

    const [instance, accessTokenRequest] = AccessToken();

    const missions: any = [
        {
            "kind":localizationService.toLanguageString('synchro.not_assigned', 'NOT_FOUND'), "value": missionsNotStarted, "color": "#018CA5"
        },
        {
            "kind":localizationService.toLanguageString('synchro.assigned', 'NOT_FOUND'), "value": missionsAssigned, "color": "#54A2B4"
        },
        {
            "kind":localizationService.toLanguageString('synchro.doing', 'NOT_FOUND'), "value": missionsDoing, "color": "#74C3EE"
        },
    ];

    useEffect(() => {
        getStatusMissions('palpie');
    }, []);

    const getStatusMissions = async (typeMission?:any) => {
        let languageId = localStorage.getItem('languageId');

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId  };
            const params = {
                type: typeMission
            };
            try {
                const res = await axios.get(`${SERVER_URL}/synchro/getmissionsperstates`, { headers, params })
                const data = res.data.data
                
                setMissionsNotStarted(data.notStarted)
                setMissionsAssigned(data.assigned)
                setMissionsDoing(data.doing)
                
                setMissionsTotal(data.notStarted + data.assigned + data.doing)
                
            }catch (error: any) {
                setError(error);
            }
        }
        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const labelContent = (e: any) => (e.category);    

    return(
    <Chart>
        <ChartTitle 
            color='#838393' 
            text={`${localizationService.toLanguageString('synchro.missions_type', 'NOT_FOUND')}: \n PALPIE(${localizationService.toLanguageString('synchro.missions', 'NOT_FOUND')} ${missionsTotal}) `}             
        />
        <ChartSeries>
            <ChartSeriesItem type="donut" data={missions.missionsNotStarted || missions.missionsAssigned || missions.missionsDoing} categoryField="kind" field="value" color={missions.color}>
                {/*<ChartSeriesLabels color="#fff" background="none" content={labelContent} />*/}
            </ChartSeriesItem>
        </ChartSeries>
        <ChartLegend position="bottom" reverse={false} labels={{ color: "#018CA5" }} />
        <ChartNoDataOverlay children={localizationService.toLanguageString('synchro.no_data', 'NOT_FOUND')} />
    </Chart>
    )
}